export default {
  bad_connection: 'عفوا، هناك خطأ ما. الرجاء التحقق من اتصال الشبكة ثم حاول مرة أخرى',
  send: 'يرسل',
  select_hotel: 'يرجى اختيار الفندق الذي تقيم فيه',
  select_language: 'الرجاء اختيار لغتك.',
  start_chatting: 'ابدأ الدردشة',
  languages: 'اللغات',
  menu: 'قائمة طعام',
  close: 'يغلق',
  back: 'خلف',
  next: 'التالي',
  message: 'من فضلك اطرح سؤالا',
  search: 'يبحث',
  select: 'يختار',
  sign_in: 'تسجيل الدخول',
  sign_out: 'خروج',
  sign_up: 'اشتراك',
  smoking: 'التدخين',
  no_smoking: 'غير مدخن',
  adults: 'الكبار',
  xAdults: 'الكبار',
  children: 'طفل',
  ageOfChild: 'عمر الطفل',
  seeAll: 'اظهار الكل',
  email: 'بريد إلكتروني',
  email_confirmation: 'البريد الإلكتروني (للتأكيد)',
  phone_number: 'رقم التليفون',
  icc: 'المحكمة الجنائية الدولية',
  month: 'شهر',
  year: 'سنة',
  including_taxes: 'متضمن للضريبة',
  excluding_taxes: 'لا تشمل الضريبة',
  show_more: 'أظهر المزيد',
  show_less: 'عرض أقل',
  file_upload: {
    unsupported_file_type: 'عذرًا، نحن لا ندعم الملفات من النوع {file_type}',
    file_size_exceeded: 'الملف يتجاوز الحد الأقصى للحجم وهو 10 ميغابايت',
    file_upload_failed: 'فشل تحميل الملف',
    max_files_upload_simultaneously: 'يمكن تحميل 5 ملفات كحد أقصى في وقت واحد'
  },
  base: {
    back_to_list: 'الرجوع للقائمة',
    pay: 'يدفع',
    cancel: 'يلغي',
    delete: 'يمسح',
    yes: 'نعم',
    no: 'لا',
    book: 'كتاب',
    direct_price: 'السعر المباشر',
    membership_rate: 'معدل العضوية',
    regular_rate: 'معدل منتظم',
    expand_for_price: 'قم بالتوسيع للمقارنة',
    confirmSelection: 'تأكيد التحديدات',
    neverAskAgain: 'لا تسأل مرة أخرى',
    accept: 'يقبل',
    do_not_accept: 'لا تقبل',
    password: 'كلمة المرور',
    email: 'بريد إلكتروني',
    save: 'يحفظ',
    confirm_password: 'تأكيد كلمة المرور',
    error02: 'حدث خطأ أثناء معالجة. الرجاء معاودة المحاولة في وقت لاحق.',
    errorCode: {
      3001: 'لقد حدث خطأ في المهلة. لم تتم معالجة الدفعة.',
      3002: 'لقد فشلت عملية الدفع.',
      3003: 'هذه البطاقة لم تكن متوفرة.',
      3004: 'يرجى تأكيد رقم البطاقة.',
      3005: 'يرجى التأكد من صحة تاريخ انتهاء الصلاحية.',
      3006: 'فشلت المصادقة الآمنة ثلاثية الأبعاد.',
      3007: 'لا يتم قبول بطاقة الائتمان أو أن رقم البطاقة غير صحيح.',
      3008: 'تم إلغاء المصادقة ثلاثية الأبعاد الآمنة.',
      3009: 'تم تعليق المصادقة ثلاثية الأبعاد الآمنة بسبب طلبات متعددة.',
      3011: 'لقد حدث خطأ في المهلة. لم تتم معالجة الدفعة.',
      3203: 'حدث خطأ أثناء معالجة. الرجاء معاودة المحاولة في وقت لاحق.',
      3204: 'لقد فشلت عملية الدفع، يرجى استخدام بطاقة أخرى، أو إعادة المحاولة لاحقاً.',
      3205: 'هذه البطاقة لم تكن متوفرة.'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: 'يرجى مراجعة المعلومات التي قمت بإدخالها.',
    INVALID_EXPIRATION_YEAR: 'يرجى التأكد من صحة تاريخ انتهاء الصلاحية.',
    Invalid_card_number: 'يرجى تأكيد رقم البطاقة.',
    Others: 'يرجى مراجعة المعلومات التي قمت بإدخالها.'
  },
  validation: {
    is_required: '{الحقل مطلوب',
    correct_email: 'يرجى إدخال عنوان البريد الإلكتروني الصحيح',
    invalid_integer: 'الرجاء إدخال عدد صحيح'
  },
  chat_body: {
    deleted_message: 'لقد حذفت هذه الرسالة',
    op_deleted_msg: 'قام المشغل بحذف هذه الرسالة',
    delete_message: 'حذف رسالة',
    delete_message_desc: 'هل أنت متأكد أنك تريد حذف هذه الرسالة؟ هذا لا يمكن التراجع عنها'
  },
  user_top: {
    information:
      'إذا كنت ترغب في مواصلة الدردشة معنا على الأجهزة الأخرى، يرجى الاشتراك. يمكنك استرداد رسائلك على أي جهاز عند تسجيل الدخول.',
    terms_and_condition: {
      before: 'بالتسجيل، أنا أوافق على',
      link: 'الشروط والأحكام',
      and: 'و',
      privacy_policy: 'سياسة الخصوصية',
      after: '.'
    },
    sign_in_with_facebook: 'قم بتسجيل الدخول باستخدام الفيسبوك',
    sign_out_with_facebook: 'قم بتسجيل الخروج من Facebook على هذا الجهاز',
    sign_in_with_line: 'تسجيل الدخول باستخدام لاين',
    sign_in_with_weibo: 'تسجيل الدخول مع ويبو',
    create_account: 'إنشاء حساب',
    or: 'أو',
    already_have_an_account: 'هل لديك حساب؟',
    sign_in_with_email: 'تسجيل الدخول بالبريد الإلكتروني',
    forgot_password: 'هل نسيت كلمة السر؟'
  },
  new_user: {
    information: 'من فضلك أدخل اسمك وعنوان بريدك الإلكتروني ثم اضغط على تسجيل.',
    information2: 'سوف تتلقى التحقق من chatbot@tripla.jp',
    first_name: 'الاسم الأول',
    last_name: 'اسم العائلة',
    name_placeholder: 'اسمك',
    email_placeholder: 'عنوان البريد الإلكتروني',
    submit: 'اشتراك',
    email_sent:
      'تم إرسال رابط التحقق إلى عنوان بريدك الإلكتروني. الرجاء النقر على الرابط الذي تم إرساله للتو و{تسجيل الدخول}',
    error_message: {
      problem:
        'حدثت مشكلة أثناء إنشاء حسابك. يرجى التحقق من عنوان بريدك الإلكتروني والمحاولة مرة أخرى.',
      email: 'البريد الإلكتروني غير صالح أو تم أخذه بالفعل'
    }
  },
  new_session: {
    information: 'الرجاء إدخال عنوان البريد الإلكتروني وكلمة المرور والضغط على تسجيل الدخول',
    email_placeholder: 'عنوان البريد الإلكتروني',
    password_placeholder: 'كلمة المرور',
    submit: 'تسجيل الدخول/تسجيل العضوية',
    error_message: {
      email: 'آسف ولكن البريد الإلكتروني الخاص بك أو كلمة المرور قد تكون غير صحيحة',
      known_user_different: 'المستخدم المعروف مختلف'
    }
  },
  destroy_session: {
    information:
      'هل تريد تسجيل الخروج؟ تحتاج إلى تسجيل الدخول مرة أخرى إذا كنت تريد عرض الرسالة الموجودة.',
    submit: 'خروج'
  },
  forgotten_password: {
    information:
      'الرجاء إدخال عنوان البريد الإلكتروني الخاص بك. سوف نرسل تأكيدا إلى حساب البريد الإلكتروني الخاص بك.',
    email_placeholder: 'عنوان البريد الإلكتروني',
    submit: 'يرسل',
    error: 'غير قادر على إعادة تعيين كلمة المرور'
  },
  forgotten_password_confirmation: {
    information:
      'ستتلقى رسالة بريد إلكتروني تحتوي على تعليمات حول كيفية إعادة تعيين كلمة المرور الخاصة بك في بضع دقائق.'
  },
  reset_password: {
    title: 'تغيير كلمة المرور',
    password_title: 'كلمة المرور',
    password_hint: '8 أحرف على الأقل',
    password_confirmation_title: 'تأكيد كلمة المرور)',
    submit: 'تغيير كلمة المرور'
  },
  set_reset_password: {
    title: 'تغيير كلمة المرور',
    information: 'تم إعادة تعيين كلمة المرور الخاصة بك.',
    information2: 'يرجى العودة إلى حيث قمت بإعادة تعيين كلمة المرور وتسجيل الدخول مرة أخرى.'
  },
  menu_items: {
    1: 'التحقق من توافر الغرفة',
    2: 'حجز غرفة',
    3: 'تأكيد حجز الغرفة'
  },
  modal: {
    back_to_chat: 'العودة إلى الدردشة'
  },
  gmoPaypalOptions: {
    visa: 'تأشيرة',
    master: 'بطاقة ماستر بطاقة ائتمان',
    mastercard: 'بطاقة ماستر بطاقة ائتمان',
    amex: 'أمريكان اكسبريس',
    jcb: 'جي سي بي',
    diners: 'نادي داينرز'
  },
  credit_card: {
    error: {
      cvv: 'يرجى التأكد من صحة CVV الخاص بك',
      expiration: 'يرجى التأكد من صحة تاريخ انتهاء الصلاحية',
      name: 'يرجى التأكد من صحة اسم حامل البطاقة',
      number: 'يرجى استخدام رقم بطاقة ائتمان صالح',
      unknown: 'حدثت مشكلة أثناء معالجة طلبك، يرجى التأكد من صحة المعلومات التي قدمتها',
      reservation_month:
        'يرجى التأكد من أن تاريخ انتهاء صلاحية بطاقة الائتمان يجب أن يكون متبقيًا لمدة شهر واحد على الأقل بعد تاريخ الحجز.'
    },
    accept: 'نحن نقبل:',
    cvv: 'CVV',
    expiration: 'تاريخ انتهاء الصلاحية',
    intro: 'الرجاء إدخال المعلومات المطلوبة للبطاقة التي ترغب في استخدامها',
    name: 'اسم حامل البطاقة',
    number: 'رقم البطاقة',
    save: 'احفظ هذه البطاقة',
    submit: 'إضافة بطاقة',
    title: 'إضافة بطاقة ائتمانية جديدة',
    security_code: 'رمز الحماية',
    card_holder_confirm: 'يرجى تأكيد اسم حامل البطاقة',
    card_holder_format_confirm: 'الرجاء إدخال اسمك بأحرف رومانية بنصف العرض.',
    expiration_confirm: 'يرجى تأكيد تاريخ انتهاء الصلاحية',
    card_cvv_confirm: 'الرجاء تأكيد رمز الحماية',
    card_number_confirm: 'يرجى تأكيد رقم البطاقة',
    card_brand: 'نوع البطاقة',
    select_card_brand: 'اختر نوع البطاقة'
  },
  payment: {
    total: 'المجموع'
  },
  currencies: {
    JPY: 'ين يابانى'
  },
  chat_channels: {
    title: 'الرجاء اختيار قناة',
    facebook: 'رسول',
    web: 'ويب',
    line: 'خط',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: 'الطلبات',
    request: 'طلب',
    status: 'حالة',
    no_data: 'ليس لديك حاليا أي طلب',
    payment: 'قسط',
    customer: 'عميل',
    phone: 'هاتف',
    people: 'الناس',
    facility_name: 'إسم المنشأة',
    requested_day: 'اليوم المطلوب',
    requested_time: 'الوقت المطلوب',
    confirm_cancel_msg:
      'يرجى تأكيد رغبتك في إلغاء هذا الطلب. سنرسل إشعارًا إلى المديرين وبمجرد اكتمال الإلغاء، ستتلقى تأكيدًا.',
    cancel_request: 'إلغاء الطلب',
    edit_request: 'تحرير الطلب',
    keep_request: 'الاحتفاظ بالطلب'
  },
  requests: {
    statuses: {
      _destroyed: 'دمرت',
      cancel_requested: 'إلغاء الطلب',
      cancelled: 'ألغيت',
      change_requested: 'التحديث مطلوب',
      created: 'مخلوق',
      departure_unconfirmed: 'المغادرة غير مؤكدة',
      done: 'منتهي',
      in_progress: 'في تَقَدم',
      no_show: 'لا تظهر',
      stopped: 'توقفت',
      wait_listed: 'قائمة الانتظار',
      waiting_detail: 'تفاصيل الانتظار'
    }
  },
  best_rate: 'أفضل سعر',
  time_picker: {
    AM: 'أكون',
    PM: 'مساءً'
  },
  details_page: {
    details: 'المزيد من التفاصيل'
  },
  date_range: {
    select: 'حدد مواعيد إقامتك',
    send: 'انقر فوق تحديد للمتابعة',
    no_disabled_dates: 'لا يمكنك تضمين تاريخ غير متاح. الرجاء اختيار النطاق الزمني الصحيح'
  },
  facebook: {
    email_sent:
      'تم إرسال رابط التحقق إلى عنوان بريدك الإلكتروني. الرجاء الضغط على الرابط للتأكيد والمتابعة',
    no_email: 'من فضلك اضف بريدك الالكتروني. سوف نرسل لك تأكيد الحجز بعد إجراء الحجز.',
    signInFailed: 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى',
    sign_out: 'الرجاء الضغط على الزر أدناه لتسجيل الخروج من الفيسبوك.'
  },
  confirm_form: {
    search: 'ابحث ثانيا',
    update_contact: 'تحديث معلومات الاتصال'
  },
  contact_form: {
    update: 'تحديث',
    submit: 'يُقدِّم',
    full_name: 'الاسم الكامل',
    family_name: 'اسم العائلة',
    first_name: 'الاسم الأول',
    cc_email: 'نسخة إلى البريد الإلكتروني ...',
    error: {
      full_name_error: 'يرجى تقديم الاسم الكامل باللغة الإنجليزية',
      tel_format_error: 'يمكن استخدام الأرقام والمسافات و+ و() كأرقام هواتف.',
      tel_length_error: 'الرجاء إدخال رقم هاتف مكون من أكثر من 9 أرقام.',
      email_format_error: 'يرجى تقديم عنوان بريد إلكتروني صالح (على سبيل المثال name@gmail.com)',
      email_confirmation_error: 'عناوين البريد الإلكتروني غير متطابقة'
    }
  },
  room_not_available: 'عذرًا، ليس لدينا أي غرف متاحة في التواريخ التي حددتها.',
  search_again: 'ابحث ثانيا',
  room_not_available_short: 'غير متاح.',
  email_form: {
    note_placeholder: 'الرجاء إدخال التفاصيل المتعلقة بطلبك'
  },
  rental_car_form: {
    pickup_title: 'متجر البيك اب',
    pickup_area: 'اختيار المنطقة',
    pickup_shop: 'اختيار المتجر',
    pickup_date_time: 'اختر تاريخا',
    return_title: 'متجر العودة',
    return_area: 'اختيار المنطقة',
    return_shop: 'اختيار المتجر',
    return_date_time: 'تاريخ العودة',
    back: 'خلف'
  },
  search_area_form: {
    select_prefecture_area: 'الرجاء تحديد المحافظة والمنطقة',
    prefecture: 'المحافظة',
    area: 'منطقة'
  },
  restaurant_form: {
    breakfast: 'إفطار',
    lunch: 'غداء',
    dinner: 'عشاء',
    main_time: 'وقت رئيسي',
    alternative_times: 'أوقات بديلة',
    pick_multiple: 'يرجى اختيار متعددة. نقترح 3',
    any_available_time: 'أي الأوقات المتاحة'
  },
  terms_of_use: 'شروط الاستخدام',
  privacy_policy: 'سياسة الخصوصية',
  browser_warning: 'متصفحك غير محدثة. يرجى تحديثه لتحسين الأمان والسرعة والخبرة على هذا الموقع.',
  for_night: 'لمدة {ن} ليلة | لمدة {ن} ليلة | لمدة {n} ليلة',
  chat_icon: {
    chat: 'محادثة'
  },
  chat_evaluation: {
    title: 'رضا العملاء',
    msg: 'يرجى تخصيص بعض الوقت لإعلامنا ما إذا كنت راضيًا عن برنامج الدردشة الآلي الخاص بنا أم لا',
    not_satisfied: 'غير راضى',
    satisfied: 'راضي'
  },
  cookie_consent: {
    title: 'إدارة موافقة ملفات تعريف الارتباط',
    necessary: 'ضروري: سجل الدردشة وحالة تسجيل الدخول',
    functional:
      'الوظيفية: تحفظ ملفات تعريف الارتباط هذه تفضيلاتك مثل سياسة الخصوصية وتخطيط برنامج الدردشة الآلية',
    performance:
      'الأداء: تساعدنا ملفات تعريف الارتباط هذه في حساب الزيارات ونقرات المستخدم لمساعدتنا في تحسين خدماتنا',
    advertising: 'الاستهداف والإعلان: ملفات تعريف الارتباط هذه تجعل الرسائل الإعلانية أكثر صلة بك',
    accept_all: 'قبول الكل',
    confirm: 'تأكيد اختياراتي',
    cookies_accepted: 'تم قبول ملفات تعريف الارتباط'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
